var _text, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewAllArabic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 16,
    viewBox: "0 0 42 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 10,
    fill: "#9C4900",
    fontFamily: "Arial",
    fontSize: 10,
    textAnchor: "middle"
  }, "\u0639\u0631\u0636 \u0627\u0644\u0643\u0644")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.796875 12.6C0.575961 12.6 0.396875 12.7791 0.396875 13C0.396875 13.2209 0.575961 13.4 0.796875 13.4L0.796875 12.6ZM41.0797 13.2828C41.2359 13.1266 41.2359 12.8734 41.0797 12.7172L38.5341 10.1716C38.3779 10.0154 38.1247 10.0154 37.9684 10.1716C37.8122 10.3278 37.8122 10.581 37.9684 10.7373L40.2312 13L37.9684 15.2627C37.8122 15.4189 37.8122 15.6722 37.9684 15.8284C38.1247 15.9846 38.3779 15.9846 38.5341 15.8284L41.0797 13.2828ZM0.796875 13.4L40.7969 13.4L40.7969 12.6L0.796875 12.6L0.796875 13.4Z",
    fill: "#9C4900"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllArabic);
export default __webpack_public_path__ + "static/media/view-all_arabic.92c5ee4b2391afd968d883413049132b.svg";
export { ForwardRef as ReactComponent };